import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "led-selector" }
const _hoisted_2 = { class: "led-grid" }
const _hoisted_3 = ["onClick", "aria-label"]
const _hoisted_4 = { class: "led-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "INDICATOR COLOR", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leds, (led) => {
        return (_openBlock(), _createElementBlock("div", {
          key: led.id,
          class: "led-item"
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (_ctx.selectLED(led.id)),
            class: _normalizeClass(['led-preview', { active: _ctx.currentLED === led.id }]),
            style: _normalizeStyle(_ctx.getLEDStyle(led.id)),
            "aria-label": led.displayName
          }, null, 14, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(led.displayName), 1)
        ]))
      }), 128))
    ])
  ]))
}